export const RESET = 'EXCMRELATIONUSERDATA_UPDATE_RESET'
export const SET_ERROR = 'EXCMRELATIONUSERDATA_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMRELATIONUSERDATA_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMRELATIONUSERDATA_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMRELATIONUSERDATA_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMRELATIONUSERDATA_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMRELATIONUSERDATA_UPDATE_UPDATE_RETRIEVED'
